import React, { useState } from "react";
import { ISubTreatment } from "../types/clinic.types";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import bookUrl from "../../../../api/bookUrl";
interface Props {
  subTreatment: ISubTreatment | null; // null for 'Add', object for 'Edit'
  onClose: () => void;
  onSave: (subTreatment: ISubTreatment) => void;
}

const DEFAULT_SUB_TREATMENT: Omit<ISubTreatment, "id"> = {
  subTreatment: "",
  description: "",
  localPrice: 0,
  duration: 0,
  foreignerPrice: 0,
  minlocalPrice: 0,
  minforeignerPrice: 0,
  maxlocalPrice: 0,
  maxforeignerPrice: 0,
  note: 0,
};

export const SubTreatmentFormModal: React.FC<Props> = ({
  subTreatment,
  onClose,
  onSave,
}) => {
  const [formData, setFormData] = useState(
    subTreatment || DEFAULT_SUB_TREATMENT
  );
  const isEditMode = !!subTreatment;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) || 0 : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData as ISubTreatment);

    
   
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h3>
              {isEditMode ? "Edit Sub-Treatment" : "Add New Sub-Treatment"}
            </h3>
            <button
              type="button"
              className="btn btn-icon modal-close-btn"
              onClick={onClose}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Sub-Treatment Name</label>
              <input
                type="text"
                name="subTreatment"
                value={formData.subTreatment}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Description </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Duration (min)</label>
              <input
                type="number"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Local Price</label>
              <input
                type="number"
                name="localPrice"
                value={formData.localPrice}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Foreigner Price</label>
              <input
                type="number"
                name="foreignerPrice"
                value={formData.foreignerPrice}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Local Price min-max</label>
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="number"
                  name="minlocalPrice"
                  value={formData.minlocalPrice}
                  onChange={handleChange}
                  placeholder="min"
                  required
                />
                <input
                  type="number"
                  name="maxlocalPrice"
                  value={formData.maxlocalPrice}
                  onChange={handleChange}
                  placeholder="max"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label>Foreigner Price min-max</label>
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="number"
                  name="minforeignerPrice"
                  value={formData.minforeignerPrice}
                  onChange={handleChange}
                  placeholder="min"
                  required
                />
                <input
                  type="number"
                  name="maxforeignerPrice"
                  value={formData.maxforeignerPrice}
                  onChange={handleChange}
                  placeholder="max"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label>note </label>
              <textarea
                name="note"
                value={formData.note}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              <SaveAltIcon /> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
